export default "__VITE_ASSET__CktV6CPP__";